import { z } from "zod";
import { apiGet } from "./client";

export const VenueTypeSchema = z.enum([
  "journal",
  "conference",
  "workshop",
  "preprint",
  "book_chapter",
  "thesis",
  "other",
]);
export type VenueType = z.infer<typeof VenueTypeSchema>;

export const SourceNameSchema = z.enum(["open_alex", "orcid", "semantic_scholar", "scholar"]);

export const SourceRecordSchema = z.object({
  source: SourceNameSchema,
  raw_id: z.string(),
  fetched_at: z.string(),
});

export const PublicationSchema = z.object({
  id: z.string(),
  doi: z.string().nullable(),
  arxiv_id: z.string().nullable(),
  title: z.string(),
  authors: z.array(z.string()),
  year: z.number().int(),
  venue: z.string().nullable(),
  venue_type: VenueTypeSchema,
  abstract_text: z.string().nullable(),
  citations: z.number().int().nullable(),
  url: z.string().nullable(),
  hidden: z.boolean(),
  source_records: z.array(SourceRecordSchema),
});
export type Publication = z.infer<typeof PublicationSchema>;

export const PublicationListSchema = z.array(PublicationSchema);

export async function fetchPublications(): Promise<Publication[]> {
  return apiGet("/publications", PublicationListSchema);
}
